import { Component, Input, OnInit, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestConversationItem, TestQuestion, QuestionOption } from '../../../../core/models/placement/placement.model';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-question-review',
  standalone: true,
  imports: [CommonModule,RouterModule],
  templateUrl: './question-review.component.html',
  styleUrls: ['./question-review.component.scss']
})
export class QuestionReviewComponent implements OnInit {
  @Input() questions: TestConversationItem[] = [];
  @Input() isPaid: boolean = false;
  currentIndex = 0;

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChildren('questionItem') questionItems!: QueryList<ElementRef>;

  ngOnInit(): void {
  }

  get currentQuestion() {
    return this.questions ? this.questions[this.currentIndex] : null;
  }

  selectQuestion(index: number) {
    this.currentIndex = index;
    this.scrollToQuestion(index);
  }

  isCorrect(question: TestConversationItem): boolean {
    return question?.evaluation?.answer_type?.toLowerCase() === 'correct';
  }

  isSkipped(question: TestConversationItem): boolean {
    return question?.is_skipped || question?.evaluation?.answer_type?.toLowerCase() === 'skipped';
  }

  isWrong(question: TestConversationItem): boolean {
    return !this.isCorrect(question) && !this.isSkipped(question);
  }

  getStatusClass(question: TestConversationItem): string {
    if (this.isCorrect(question)) return 'status-correct';
    if (this.isSkipped(question)) return 'status-skipped';
    return 'status-wrong';
  }

  getOptionLetter(index: number): string {
    return String.fromCharCode(65 + index);
  }

  isOptionSelected(question: TestConversationItem, option: QuestionOption): boolean {

    return question?.user_answer === option?.text;
  }

  isOptionCorrect(question: TestConversationItem, option: QuestionOption): boolean {


    return option?.text?.trim().toLowerCase() === question?.evaluation?.correct_answer?.trim().toLowerCase();
  }

  scrollToQuestion(index: number) {
    if (!this.scrollContainer || !this.questionItems) return;

    const container = this.scrollContainer.nativeElement;
    const items = this.questionItems.toArray();

    if (items[index]) {
      const element = items[index].nativeElement;

      const containerRect = container.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      const relativeTop = elementRect.top - containerRect.top + container.scrollTop;

      container.scrollTo({
        top: relativeTop - 20, // Add a little buffer
        behavior: 'smooth'
      });
    }
  }

  getOptionIndex(question: TestConversationItem, optionId: string): number {
    const q = question.question as TestQuestion;
    return q?.options?.findIndex((o: QuestionOption) => o.option_id === optionId);
  }

  getOptionIndexByText(question: TestConversationItem, text: string): number {
    const q = question.question as TestQuestion;
    return q?.options?.findIndex((o: QuestionOption) => o.text?.trim() === text?.trim());
  }

  getOptionLetterFromIndex(index: number): string {
    if (index === -1 || index === undefined) return '-';
    return String.fromCharCode(65 + index);
  }
}
